import { render, staticRenderFns } from "./RepresentationModal.vue?vue&type=template&id=51175cc6&"
import script from "./RepresentationModal.vue?vue&type=script&lang=js&"
export * from "./RepresentationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports